export default __webpack_public_path__ + "static/webinarVLMCTA_bg-733cc8517eb25f7833628ae988b5a5f9.png";